module.exports={CONTACT:"Ponte en contacto con nosotros"};